/**
 * Fickle Frenchy — Theme JavaScript
 * Handles: Slideshow, Mobile Menu, Cart Drawer, Product Page interactions,
 * Sticky ATC bar, Scroll animations
 */

(function () {
  'use strict';

  /* ========== SLIDESHOW ========== */
  function initSlideshow() {
    const slideshows = document.querySelectorAll('[data-section-type="slideshow"]');
    slideshows.forEach(function (section) {
      const slides = section.querySelectorAll('.slideshow__slide');
      const dots = section.querySelectorAll('.slideshow__dot');
      if (slides.length < 2) return;

      let current = 0;
      const speed = parseInt(section.dataset.autoplaySpeed || '5', 10) * 1000;

      function goTo(index) {
        // Pause videos in the outgoing slide
        slides[current].querySelectorAll('video').forEach(function (v) { v.pause(); });
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = index;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
        // Play videos in the incoming slide
        slides[current].querySelectorAll('video').forEach(function (v) { v.play(); });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
        });
      });

      setInterval(function () {
        goTo((current + 1) % slides.length);
      }, speed);
    });
  }

  /* ========== MOBILE MENU ========== */
  function initMobileMenu() {
    const toggles = document.querySelectorAll('.js-mobile-menu-toggle');
    const menu = document.querySelector('.js-mobile-menu');
    if (!menu) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        menu.classList.toggle('is-open');
        document.body.style.overflow = menu.classList.contains('is-open') ? 'hidden' : '';
      });
    });
  }

  /* ========== CART DRAWER ========== */
  function initCartDrawer() {
    const drawer = document.querySelector('.js-cart-drawer');
    const overlay = document.querySelector('.js-overlay');

    if (!drawer) return;

    window.toggleCart = function (forceOpen) {
      if (typeof forceOpen === 'boolean') {
        if (forceOpen) {
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-visible');
          document.body.style.overflow = 'hidden';
        } else {
          drawer.classList.remove('is-open');
          if (overlay) overlay.classList.remove('is-visible');
          document.body.style.overflow = '';
        }
      } else {
        drawer.classList.toggle('is-open');
        if (overlay) overlay.classList.toggle('is-visible');
        document.body.style.overflow = drawer.classList.contains('is-open') ? 'hidden' : '';
      }
    };

    function attachCartListeners() {
      document.querySelectorAll('.js-cart-toggle').forEach(function (btn) {
        // Remove existing listeners to avoid duplicates when re-rendering
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        newBtn.addEventListener('click', function (e) {
          e.preventDefault();
          window.toggleCart();
        });
      });

      const drawerContent = document.getElementById('cart-drawer-content');
      if (!drawerContent) return;

      drawerContent.querySelectorAll('.js-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const line = this.dataset.line;
          const qty = this.dataset.qty;
          updateCartLine(line, qty);
        });
      });

      drawerContent.querySelectorAll('.js-remove-item').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          const line = this.dataset.line;
          updateCartLine(line, 0);
        });
      });

      drawerContent.querySelectorAll('.js-upsell-add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const id = this.dataset.id;
          addToCart(id, 1);
        });
      });

      const prevBtn = drawerContent.querySelector('.js-upsell-prev');
      const nextBtn = drawerContent.querySelector('.js-upsell-next');
      const track = drawerContent.querySelector('.js-upsell-track');
      if (prevBtn && nextBtn && track) {
        prevBtn.addEventListener('click', function () {
          const card = track.querySelector('.cart-drawer__upsell-card');
          if (card) track.scrollBy({ left: -(card.offsetWidth + 16), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
          const card = track.querySelector('.cart-drawer__upsell-card');
          if (card) track.scrollBy({ left: card.offsetWidth + 16, behavior: 'smooth' });
        });
      }
    }

    function getRootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function updateCartCount() {
      fetch(getRootUrl() + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll('.js-cart-count').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
    }

    function refreshCartDrawer(openAfter) {
      fetch(getRootUrl() + '?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const newDrawerInfo = temp.querySelector('#cart-drawer-content');
          if (newDrawerInfo) {
            document.getElementById('cart-drawer-content').innerHTML = newDrawerInfo.innerHTML;
            attachCartListeners();
            updateCartCount();
            if (openAfter) window.toggleCart(true);
          }
        });
    }

    function updateCartLine(line, qty) {
      fetch(getRootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(() => refreshCartDrawer(false));
    }

    function addToCart(id, qty) {
      fetch(getRootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      })
        .then(res => res.json())
        .then(() => refreshCartDrawer(true));
    }

    // Intercept Add to Cart forms
    document.addEventListener('submit', function (e) {
      if (e.target.action && e.target.action.indexOf('/cart/add') !== -1 && !e.target.classList.contains('cart-drawer__form')) {
        e.preventDefault();
        const formData = new FormData(e.target);

        // Disable submit button temporarily
        const submitBtn = e.target.querySelector('button[type="submit"]');
        if (submitBtn) {
          const origText = submitBtn.innerHTML;
          submitBtn.innerHTML = 'Adding...';
          submitBtn.disabled = true;

          fetch(getRootUrl() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          })
            .then(res => res.json())
            .then(() => {
              refreshCartDrawer(true);
              submitBtn.innerHTML = origText;
              submitBtn.disabled = false;
            })
            .catch(err => {
              console.error(err);
              submitBtn.innerHTML = origText;
              submitBtn.disabled = false;
            });
        }
      }
    });

    attachCartListeners();
  }

  /* ========== PRODUCT PAGE ========== */
  function initProductPage() {
    // Thumbnail gallery
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');
    const mainImg = document.getElementById('product-main-img');

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.dataset.imageSrc;
          mainImg.alt = thumb.dataset.imageAlt || '';
        }
      });
    });

    // Sticky ATC bar
    var stickyBar = document.getElementById('sticky-atc');
    var productForm = document.getElementById('product-form');
    if (stickyBar && productForm) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            stickyBar.classList.add('is-visible');
          }
        });
      }, { threshold: 0 });
      observer.observe(productForm);
    }
  }

  /* Purchase option toggle */
  window.selectPurchaseOption = function (el) {
    var options = el.parentElement.querySelectorAll('.purchase-option');
    options.forEach(function (o) { o.classList.remove('is-selected'); });
    el.classList.add('is-selected');

    var freqSelector = document.getElementById('frequency-selector');
    if (freqSelector) {
      freqSelector.style.display = el.dataset.option === 'subscribe' ? '' : 'none';
    }
  };

  /* Frequency toggle */
  window.selectFrequency = function (el) {
    var options = el.parentElement.querySelectorAll('.frequency-option');
    options.forEach(function (o) { o.classList.remove('is-selected'); });
    el.classList.add('is-selected');
  };

  /* Grind / Variant pill picker */
  window.selectGrind = function (el) {
    if (el.dataset.soldout) return;
    var options = el.parentElement.querySelectorAll('.grind-option');
    options.forEach(function (o) { o.classList.remove('is-selected'); });
    el.classList.add('is-selected');

    var variantId = el.dataset.variantId;
    var priceFormatted = el.dataset.priceFormatted;

    // Update hidden variant input
    var hiddenInput = document.getElementById('product-variant-id');
    if (hiddenInput) hiddenInput.value = variantId;

    // Update the dropdown selector if it exists
    var mainSelect = document.getElementById('product-variant-select');
    if (mainSelect) {
      mainSelect.value = variantId;
      window.updateVariant(mainSelect);
    }

    // Update displayed price
    var priceEl = document.getElementById('product-price');
    if (priceEl && priceFormatted) priceEl.textContent = priceFormatted;
    var stickyPrice = document.getElementById('sticky-atc-price');
    if (stickyPrice && priceFormatted) stickyPrice.textContent = priceFormatted;
  };

  /* Quantity */
  window.updateQuantity = function (delta) {
    var input = document.getElementById('product-quantity');
    if (!input) return;
    var val = parseInt(input.value, 10) + delta;
    if (val < 1) val = 1;
    input.value = val;
  };

  /* Variant sync */
  window.updateVariant = function (select) {
    document.getElementById('product-variant-id').value = select.value;
    var option = select.options[select.selectedIndex];
    var price = option.dataset.price;
    var priceEl = document.getElementById('product-price');
    var stickyPrice = document.getElementById('sticky-atc-price');
    if (priceEl && price) priceEl.textContent = price;
    if (stickyPrice && price) stickyPrice.textContent = price;

    // Sync sticky bar variant selector
    var stickySelect = document.querySelector('.sticky-atc__variant-select');
    if (stickySelect) stickySelect.value = select.value;
  };

  window.syncVariant = function (select) {
    var mainSelect = document.getElementById('product-variant-select');
    if (mainSelect) {
      mainSelect.value = select.value;
      window.updateVariant(mainSelect);
    }
  };

  /* Testimonial carousel scroll */
  window.scrollTestimonials = function (direction) {
    var track = document.getElementById('testimonial-track');
    if (!track) return;
    var cardWidth = track.querySelector('.product-testimonials__card');
    var scrollAmount = cardWidth ? (cardWidth.offsetWidth + 24) : 360;
    track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  };

  /* Featured collection carousel scroll */
  window.scrollFeaturedCollection = function (sectionId, direction) {
    var grid = document.getElementById('product-grid-' + sectionId);
    if (!grid) return;
    var card = grid.querySelector('.product-card');
    var gap = parseFloat(window.getComputedStyle(grid).columnGap || window.getComputedStyle(grid).gap) || 24;
    var scrollAmount = card ? (card.offsetWidth + gap) : 320;
    grid.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  };

  /* ========== SCROLL ANIMATIONS ========== */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.fade-in-up');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ========== INIT ========== */
  document.addEventListener('DOMContentLoaded', function () {
    initSlideshow();
    initMobileMenu();
    initCartDrawer();
    initProductPage();
    initScrollAnimations();
  });

})();
